import _ from "lodash";
import { getDateKey } from "../shipment-review-grid";
import { SizeData } from "components/shipment-review/types";
import { IDateRange, IGridEntry } from "types/cart/shipment-review";

/**
 * TODO: replace with getSizes
 * @deprecated use {@link getSizes} instead
 */
export const buildSizes = (entries: IGridEntry[], { range, ...filters }: Record<string, any> & { range: IDateRange }) =>
    entries.reduce(
        (accumulator, entry) => {
            const itemDateKey = getDateKey(entry.shipStart, entry.shipEnd);
            const { size, unitsPerPack, id } = entry;

            const wholesalePrice = entry.pricing?.wholesale;
            const originalWholesalePrice = entry.pricing?.original_wholesale ?? wholesalePrice;
            const retailPrice = entry.pricing?.retail;

            const sizeData = {
                available: entry.inventory?.available,
                displayQuantity: entry.inventory?.displayQuantity,
                size: entry.size,
                unitsPerPack,
                allocated: entry.allocated,
                isVirtual: !entry.cartLineItemId,
                isOverordered: entry.isOverordered,
                pricing: {
                    retailPrice,
                    wholesalePrice,
                    originalWholesalePrice,
                },
            };

            if (range.dateKey === itemDateKey && _.every(filters, (value, path) => _.get(entry, path) === value)) {
                accumulator[size.size] = _.defaults(sizeData, { id, quantity: entry?.quantity ?? 0 });
                // If size has been defined before, we don't want to assign ZERO value
            } else if (!accumulator[size.size]) {
                // add size with qty 0 for row with date and size which not have LI but should be shown in grid
                accumulator[size.size] = _.defaults(sizeData, { id: null, quantity: 0 });
            }
            return accumulator;
        },
        {} as Record<string, SizeData>,
    );

export const getSizes = (entries: IGridEntry[]) => {
    const map: Record<string, SizeData> = {};
    _.forEach(entries, (e) => {
        map[e.size.size] = {
            id: e.size._id,
            quantity: e?.quantity ?? 0,
            available: e.inventory?.available,
            displayQuantity: e.inventory?.displayQuantity,
            size: e.size,
            unitsPerPack: e.unitsPerPack,
            allocated: e.allocated,
            isVirtual: !e.cartLineItemId,
            isOverordered: e.isOverordered,
            pricing: {
                wholesalePrice: e.pricing?.wholesale,
                originalWholesalePrice: e.pricing?.adjusted_wholesale ?? e.pricing?.original_wholesale,
                retailPrice: e.pricing?.retail,
                discountedPrice: e.pricing?.discounted_price,
            },
        };
    });
    return map;
};
